import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import DrilldownInput from "components/DrilldownInput";
import { FormLabel } from "@material-ui/core";
import ODASelector from "MetaComponent/selectors/ODA";
import DesignSelector from "MetaComponent/selectors/Design";
import OdaAction from "MetaComponent/actions/ODA";

export const styles = {
  drillDown: {
    marginBottom: 20,
    textAlign: "left"
  }
};

export class OdaJobDropdown extends PureComponent {
  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedDesignJobId !== this.props.selectedDesignJobId) {
      this.init();
    }
  }

  getJobsList = jobs => {
    const { selectedJobId } = this.props;
    return jobs.map(job => {
      const label = this.getJobLabel(job);
      return {
        id: job.id,
        text: label,
        isSelected: job.id === selectedJobId
      };
    });
  };

  getJobLabel = job => {
    return job ? `${job.name} - ${job.status}` : "";
  };

  /**
   * it sets the selected job id in the state
   * @param {String} selectedOptionIndex - the index of the selected option
   * @callback
   */
  onJobSelect = selectedOptionIndex => {
    const { selectJob } = this.props;
    const selectedJobId = parseInt(
      this.props.odaJobs[selectedOptionIndex].id,
      10
    );
    selectJob(selectedJobId);
  };

  /**
   * validates the currently selected analysis job id to make sure it is remembered
   * and it makes sense.
   */
  init() {
    const {
      odaJobs,
      selectedJobId,
      selectedDesignJobId,
      selectJob
    } = this.props;

    const aDesignJobIsSelected = selectedDesignJobId !== null;
    const thereIsOdaJob = odaJobs.length > 0;
    const thereIsOdaJobThatBelongsToSelectedDesignJob =
      aDesignJobIsSelected &&
      thereIsOdaJob &&
      odaJobs.find(job => job.design_job === selectedDesignJobId);
    const thereIsNoSelectedOdaJob = selectedJobId === null;
    const selectedOdaJobExists =
      !thereIsNoSelectedOdaJob && odaJobs.find(job => job.id === selectedJobId);
    const selectedOdaJobBelongsToSelectedDesignJob =
      selectedOdaJobExists &&
      odaJobs.find(job => job.id === selectedJobId).design_job ===
        selectedDesignJobId;

    if (
      aDesignJobIsSelected &&
      thereIsOdaJobThatBelongsToSelectedDesignJob &&
      (thereIsNoSelectedOdaJob ||
        !selectedOdaJobExists ||
        !selectedOdaJobBelongsToSelectedDesignJob)
    ) {
      const last = [...odaJobs]
        .reverse()
        .find(job => job.design_job === selectedDesignJobId);
      selectJob(last.id);
    } else if (
      !aDesignJobIsSelected ||
      !thereIsOdaJobThatBelongsToSelectedDesignJob
    ) {
      selectJob(null);
    }
  }

  render() {
    const { odaJobs, classes, selectedJobId } = this.props;
    return (
      <div className={classes.drillDown}>
        <FormLabel>ODA Job</FormLabel>
        <DrilldownInput
          name="OdaJob"
          marginTop={10}
          onClose={(value, data) => {}}
          options={[this.getJobsList(odaJobs)]}
          showCount={false}
          value={
            selectedJobId
              ? this.getJobLabel(
                  odaJobs.filter(job => job.id === selectedJobId)[0]
                )
              : ""
          }
          onSelect={this.onJobSelect}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedJobId: ODASelector.getSelectedJobId(state),
    selectedDesignJobId: DesignSelector.getSelectedJobId(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectJob: jobId => dispatch(OdaAction.selectJob(jobId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(OdaJobDropdown));
